import { generateClient } from 'aws-amplify/api';
import { campaignParams } from './campaignAttribution';

const LEAD_EMAIL_KEY = 'tekyu_lead_email';
const LEAD_CONTEXT_KEY = 'tekyu_lead_context';

export function getLeadEmail() {
  try {
    const email = localStorage.getItem(LEAD_EMAIL_KEY);
    return email && typeof email === 'string' ? email : null;
  } catch {
    return null;
  }
}

export function setLeadEmail(email) {
  try {
    localStorage.setItem(LEAD_EMAIL_KEY, email);
  } catch {
    // ignore
  }
}

export function getUtmParams() {
  try {
    return campaignParams(window.location.search);
  } catch {
    return {};
  }
}

export function buildLeadContext({ roleKey } = {}) {
  const utm = getUtmParams();
  let pathname = '';
  try {
    pathname = window.location.pathname;
  } catch {
    // ignore
  }

  return {
    roleKey: roleKey || null,
    pathname: pathname || null,
    utm,
    capturedAt: new Date().toISOString(),
  };
}

export function persistLeadContext(context) {
  try {
    localStorage.setItem(LEAD_CONTEXT_KEY, JSON.stringify(context));
  } catch {
    // ignore
  }
}

export function isValidEmail(email) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(email || '').trim());
}

/**
 * Saves an email lead through the API and caches it only after server acknowledgement.
 * Returns { ok: boolean, error?: string }.
 */
export async function saveLeadEmail({ email, roleKey, marketingConsent = false } = {}) {
  const normalized = String(email || '').trim().toLowerCase();
  if (!isValidEmail(normalized)) {
    return { ok: false, error: 'Please enter a valid email address.' };
  }

  const context = buildLeadContext({ roleKey });
  try {
    const response = await generateClient().graphql({
      query: `mutation CaptureLead($input: CreateEmailListInput!) {
        createEmailList(input: $input) { id }
      }`,
      authMode: 'apiKey',
      variables: { input: {
        email: normalized, dateAdded: context.capturedAt,
        context: JSON.stringify(context), marketingConsent: marketingConsent === true,
        consentVersion: 'tekyu-2026-09-26',
      } },
    });
    if (response.errors?.length || !response.data?.createEmailList?.id) throw new Error('Save failed');
    persistLeadContext(context);
    setLeadEmail(normalized);
    return { ok: true };
  } catch {
    return { ok: false, error: 'Your email was not saved. Please check your connection and try again.' };
  }
}

export function buildBootcampUrl({
  utmMedium = 'roadmap',
  utmCampaign = 'bootcamp',
} = {}) {
  const params = new URLSearchParams(getUtmParams());
  if (!params.get('utm_source')) params.set('utm_source', 'tekyu');
  if (!params.get('utm_medium')) params.set('utm_medium', utmMedium);
  if (!params.get('utm_campaign')) params.set('utm_campaign', utmCampaign);
  return `https://www.cyberagoge.com/bootcamp/?${params.toString()}`;
}
